export default __webpack_public_path__ + "img/ec6466575f0ab853b553a71230fe6279.svg";